<template>
  <v-container pa-0 ma-0>
      <UserAvatarCase
        v-for="(viewer, index) in caseViewers" :key="index"
        status="active"
        :user-id="viewer.userId || viewer.id"
        :name="viewer.userDisplayName || viewer.displayName">
      </UserAvatarCase>
      <span class="ml-1" v-if="caseViewerOverflowCount > 0"> + {{caseViewerOverflowCount}}</span>
  </v-container>
</template>

<script>
import UserAvatarCase from "@/components/Users/UserAvatarCase.vue"
import { mapState } from "vuex"

export default {
  name: "case-presence-display-header",
  components: { UserAvatarCase },
  props: {
    viewers: { default: () => [] },
    viewerMax: { default: () => 3 },
    bucketView: { default: () => false }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.currentUser.me.id
    }),
    avatarOnly() {
      if (this.bucketView) {
        return this.bucketView
      } else {
        return this.$vuetify.breakpoint.smAndDown
      }
    },
    caseViewers() {
      if (this.viewers && this.viewers.length > 0) {
        const all = this.viewers.filter(viewer => viewer.id !== this.currentUserId) // Excluding current user
        return all.slice(0, this.viewerMax)
      } else {
        return []
      }
    },
    caseViewerOverflowCount() {
      if (this.viewers && this.viewers.length > this.viewerMax) {
        return this.bucketView ? this.viewers.length - this.viewerMax : this.viewers.length - this.viewerMax - 1 // Excluding current user
      } else {
        return 0
      }
    }
  }
}
</script>
